export const en = {
    /**
     * Main
     * 
     * @name No Particular Name
     * @file Overall exists in multiple files
     */
    "ToDo": "ToDo",
    "Todo List": "Todo List",
    "Todo list for managing multiple tasks.": "Todo list for managing multiple tasks.",

    /**
     * Switch Locale
     * 
     * @name SwitchLocale.js
     * @file src://Components/SwitchLocale.js
     */
    "Change Locale": "Change Locale",

    /**
     * Sign In
     * 
     * @name SignIn.js
     * @file src://Pages/SignIn.js
     */
    "Sign In": "Sign In",
    "Instead": "Instead",
    "Password": "Password",
    "Full Name": "Full Name",
    "Remember me": "Remember me",
    "Loggin Successful": "Loggin Successful",
    "User not registered": "User not registered",
    "Invalid Credentials": "Invalid Credentials",
    "Something went wrong": "Something went wrong",
    "This field is required": "This field is required",
    "This field is invalid": "This field is invalid",
    
    /**
     * Sign Up
     * 
     * @name SignUp.js
     * @file src://Pages/SignUp.js
     */
    "Sign Up": "Sign Up",
    "Select your avatar": "Select your avatar",
    "User already exists": "User already exists",
    "Please select your avatar": "Please select your avatar",
    "User Successfully Registered": "User Successfully Registered",
    "Selected avatar size too large": "Selected avatar size too large",
    
    /**
     * Todo List
     * 
     * @name TodoList.js
     * @file src://Pages/User/Tasks/TodoList.js
     */
    "User": "User",
    "Task": "Task",
    "Loading": "Loading",
    "Status": "Status",
    "Actions": "Actions",
    "Priority": "Priority",
    "Edit Todo": "Edit Todo",
    "Delete Todo": "Delete Todo",
    "User not found": "User not found",
    "No Result Found": "No Result Found",

    /**
     * Search Bar
     * 
     * @name SearchBar.js
     * @file src://Components/List/Helpers/SearchBar.js
     */
    "Items": "Items",
    "Search": "Search",
    "Type Here": "Type Here",
    "Search for task": "Search for task",

    /**
     * Create Todo
     * 
     * @name CreateTodo.js
     * @file src://Pages/User/Tasks/Components/Models/CreateTodo.js
    */
    "Add": "Add",
    "Task": "Task",
    "Close": "Close",
    "Status": "Status",
    "Priority": "Priority",
    "Task Work": "Task Work",
    "Create Todo": "Create Todo",
    "Something went wrong": "Something went wrong",
    "Task successfully created": "Task successfully created",

    /**
     * Edit Todo
     * 
     * @name EditTodo.js
     * @file src://Pages/User/Tasks/Components/Models/EditTodo.js
     */
    "Edit": "Edit",
    "Edit Todo": "Edit Todo",
    "Something went wrong": "Something went wrong",
    "Task successfuly update": "Task successfuly update",

    /**
     * Delete Todo
     * 
     * @name DeleteTodo.js
     * @file src://Pages/User/Tasks/Components/Models/DeleteTodo.js
     */
    "Delete": "Delete",
    "Delete Todo": "Delete Todo",
    "Are You Sure": "Are You Sure",
    "It can not be undone": "It can not be undone",
    "Task successfuly deleted": "Task successfuly deleted",
    
    /**
     * Mass Delete Todo
     * 
     * @name MassDeleteTodo.js
     * @file src://Pages/User/Tasks/Components/Models/MassDeleteTodo.js
     */
    "Mass Delete Todo": "Mass Delete Todo",
    
    /**
     * Progress
     * 
     * @name Progress.js
     * @file src://Components/List/Helpers/Progress.js
    */
    "Closed": "Closed",
    "Opened": "Opened",
    "Pending": "Pending",
    
    /**
     * Info Cards
     * 
     * @name InfoCards.js
     * @file src://Components/List/Helpers/InfoCards.js
     */
    "Low": "Low",
    "High": "High",
    "Medium": "Medium",
    
    /**
     * NavBar
     * 
     * @name NavBar.js
     * @file src://Components/NavBar.js
     */
    "Profile": "Profile",
    "Nav Bar": "Nav Bar",
    "Sign Out": "Sign Out",
    "Exchanger": "Exchanger",
    "Select File": "Select File",
    "Signed in as": "Signed in as",
    "Profile Edit": "Profile Edit",

    /**
     * Profile
     * 
     * @name Profile.js
     * @file src://Pages/User/Settings/Profile.js
     */
    "Edit": "Edit",
    "Edit Profile": "Edit Profile",
    "Profile successfully updated": "Profile successfully updated",
    "User already exists with same name": "User already exists with same name",

    /**
     * Exchanger
     * 
     * @name Exchanger.js
     * @file src://Pages/User/Settings/Exchanger.js
     */
    "Import": "Import",
    "Export": "Export",
    "File size too large": "File size too large",
    "Please select your file": "Please select your file",
    "Task successfully imported": "Task successfully imported",
    "Task successfully exported": "Task successfully exported",
    "Only these types are supported!": "Only these types are supported! [{{types, field}}]",
    "Import may over write your previous todos": "Import may over write your previous todos",
    
    /**
     * Exchanger
     * 
     * @name Error.js
     * @file src://Pages/Error.js
     */
    "404": "404",
    "Go to home": "Go to home",
    "This page could not be found.": "This page could not be found.",
};